<crm-single-select
  [options]="options"
  [(selectedItem)]="periodicity"
  (selectedItemChange)="periodicityChange.emit($event)"
  [appendTo]="appendTo"
  [styleClass]="styleClass"
  [class]="class"
  [isTemplateCombined]="true">
  <ng-template
    #itemTemplate
    let-item="item">
    {{ item.value | periodicity }}
  </ng-template>
</crm-single-select>
